import { render, staticRenderFns } from "./SiteForms.vue?vue&type=template&id=f2de2f10&scoped=true&"
import script from "./SiteForms.vue?vue&type=script&lang=js&"
export * from "./SiteForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2de2f10",
  null
  
)

export default component.exports